import React from 'react';

import BrandCaretDownIcon from '../icons/BrandCaretDownIcon';
import BrandCaretUpDownIcon from '../icons/BrandCaretUpDownIcon';
import BrandCaretUpIcon from '../icons/BrandCaretUpIcon';

export const ColumnSortIcon = ({ isSorted = false, isSortedDesc = false }) => {
  if (!isSorted) {
    return <BrandCaretUpDownIcon className="m-1" />;
  }

  if (isSortedDesc) {
    return <BrandCaretDownIcon className="ml-2" />;
  }
  return <BrandCaretUpIcon className="ml-2" />;

};

export default ColumnSortIcon;
